import React from "react";

const SVGClock = (<svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.6119 16.0526V10.5789M25.0001 6.47368L22.2472 3.73684M9.85892 1H15.3648M12.6119 27C9.69136 27 6.89048 25.8466 4.82537 23.7936C2.76026 21.7406 1.6001 18.9561 1.6001 16.0526C1.6001 13.1492 2.76026 10.3647 4.82537 8.31167C6.89048 6.25864 9.69136 5.10526 12.6119 5.10526C15.5324 5.10526 18.3332 6.25864 20.3984 8.31167C22.4635 10.3647 23.6236 13.1492 23.6236 16.0526C23.6236 18.9561 22.4635 21.7406 20.3984 23.7936C18.3332 25.8466 15.5324 27 12.6119 27Z"
            stroke="#3A56DF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default SVGClock